export enum EAtajoRangoTiempo {
  ULTIMOS_7_DIAS = 'ultimos7Dias',
  ESTE_MES = 'esteMes',
  MES_PASADO = 'mesPasado',
  HOY = 'hoy',
}
